export const WEBLATE_COMPONENT_NAME = 'common/smb-invoicing';
export const RECURRING_INVOICES_FEATURE_FLAG_ID = 'grandfather_recurring_invoices';
